import React, { useState, useEffect, useRef } from 'react';
import { X, Move } from 'lucide-react';

// Sürüklenebilir Modal Bileşeni
export const DraggableModal = ({ 
  isOpen, 
  onClose, 
  title, 
  subtitle, 
  children, 
  maxWidth = "max-w-2xl",
  showMoveIcon = true,
  footer,
  closeOnOverlayClick = true
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const modalRef = useRef(null);

  // Modal açıldığında pozisyonu sıfırla
  useEffect(() => {
    if (isOpen) {
      setPosition({ x: 0, y: 0 });
    }
  }, [isOpen]);

  const handleMouseDown = (e) => {
    if (e.target.closest('.no-drag')) return;
    setIsDragging(true);
    setDragStart({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - dragStart.x,
      y: e.clientY - dragStart.y
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, dragStart]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999]">
      {/* Arka plan overlay */}
      <div 
        className="absolute inset-0 bg-black/40" 
        onClick={closeOnOverlayClick ? onClose : undefined}
      />
      
      {/* Modal */}
      <div 
        ref={modalRef}
        className={`absolute top-1/2 left-1/2 bg-white rounded-lg shadow-2xl ${maxWidth} w-[95%] max-h-[85vh] flex flex-col border`}
        style={{
          transform: `translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))`,
          cursor: isDragging ? 'grabbing' : 'default'
        }}
      >
        {/* Başlık çubuğu - sürüklemek için */}
        <div 
          data-testid="draggable-modal-header"
          className="flex items-center justify-between p-4 border-b bg-gray-100 rounded-t-lg cursor-grab select-none"
          onMouseDown={handleMouseDown}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          <div className="flex items-center gap-3 flex-1 min-w-0">
            {showMoveIcon && <Move className="h-5 w-5 text-gray-400 flex-shrink-0" />}
            <div className="min-w-0 flex-1">
              <h2 className="text-lg font-semibold truncate">{title}</h2>
              {subtitle && <div className="text-sm text-gray-500 truncate">{subtitle}</div>}
            </div>
          </div>
          <button
            onClick={onClose}
            className="no-drag p-2 rounded-full hover:bg-gray-200 transition-colors flex-shrink-0 ml-2"
            aria-label="Kapat"
          >
            <X className="h-6 w-6 text-gray-600" />
          </button>
        </div>
        
        {/* Modal İçeriği */}
        <div className="p-4 overflow-y-auto flex-1 bg-white">
          {children}
        </div>
        
        {/* Footer (opsiyonel) */}
        {footer && (
          <div className="p-4 border-t bg-gray-50 rounded-b-lg">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default DraggableModal;
